import { useTranslation } from 'react-i18next'
import { isDocumentType } from '@/lib/api/documents/get-documents'

/**
 * Human label for a documents.document_type value. Unknown values (an enum
 * member added on the server before the catalogue caught up) fall back to the
 * raw code rather than a blank, so nothing silently disappears from a badge.
 */
export function useDocumentTypeLabel() {
  const { t } = useTranslation()
  return (type: string | null | undefined): string =>
    isDocumentType(type) ? t(`documents.types.${type}`) : (type ?? '')
}
